<div class="status-icon" [ngClass]="'status-' + state.nbStatus">
  <nb-icon
    [icon]="state.icon"
    [status]="state.nbStatus"
    [ngClass]="{ 'is-spinning': state.spinning }"
  ></nb-icon>
  <span class="label">{{ state.label }}</span>
</div>
